import uuid from 'uuid';
import Service from './Service';

const TOAST_ADD = 'TOAST_ADD';
const TOAST_REMOVE = 'TOAST_REMOVE';

const reducer = (state = [], action) => {
    const {type, payload} = action;
    switch (type) {
        case TOAST_ADD: {
            return [
                ...state,
                payload
            ];
        }
        case TOAST_REMOVE: {
            const i = state.findIndex(toast => toast.id === payload);
            if (i > -1) {
                return [...state.slice(0, i), ...state.slice(i + 1)];
            }
        }
    }
    return state;
};

class ToastService extends Service {
    constructor() {
        super();

        if (!ToastService.instance) {
            ToastService.instance = this;
        }

        return ToastService.instance;
    }

    getReducerName() {
        return 'toasts';
    }

    getReducer() {
        return reducer;
    }

    addToast(type, content) {
        this.addToastWithDuration(type, 0, content);
    }

    addToastWithDuration(type, duration, content) {
        const id = uuid.v4();
        this.store.dispatch({
            type: TOAST_ADD,
            payload: {
                id,
                type,
                duration,
                content
            }
        });
        if (duration > 0) {
            setTimeout(() => {
                this.removeToast(id);
            }, duration);
        }
    }

    removeToast(id) {
        this.store.dispatch({
            type: TOAST_REMOVE,
            payload: id
        });
    }

    // toast types
    WARNING = 0;
    DANGER = 1;
    SUCCESS = 2;
    INFO = 3;
}

export default new ToastService();
